export default "__VITE_ASSET__DDZbW4eK__"